import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import environment from "../../utils/Environment";
import { getGemsTokenContract } from "../../utils/contractHelpers";
import Web3 from "web3";
import { useWeb3React } from "@web3-react/core";

const Approve = () => {
  const web3 = useWeb3()
  // const tokenAddress = environment.gems;
  // const contract = getGemsTokenContract(tokenAddress, web3);
  const {account }= useWeb3React()
  const approve = useCallback(
    async (amount, tokenAddress, decimals) => {
      console.log(amount, "Amount")
      const contract = getGemsTokenContract(tokenAddress, web3);
      let nd = web3.utils.toWei(amount.toString(), "ether"); // amount * 10 ** decimals; // 0.00005
//     let amount = web3.utils.fromWei(nd.toString()); // amount / 10 ** decimals;



      console.log(nd, 'ndndndndndndndn');
      // nd = web3.utils.toWei(nd.toString(), "ether");
      try {
        const details = await contract.methods
        .approve(environment.CreditRefund, nd)
        .send({
          from: account,
          // gas,
        });
      return details;
      } catch (error) {
        console.log(error, 'Get Gems Premium approve');
        
        throw error;
      }
    },
    [web3]
  );
  return { approve: approve };
};
export default Approve;
